module.exports = __webpack_public_path__ + "static/media/pink-box.ae7df5aa.png";